import React, { Component } from 'react';
import { Input } from 'reactstrap';

export class ThemeSwitcher extends Component {
  constructor(props) {
    super(props);
    this.switchTheme = this.switchTheme.bind(this);
    this.state = { theme: props.theme };
  }

  switchTheme(e) {
    console.log('---switching theme to---\n');
    console.log(e.target.value);

    this.props.changeThemeCb(e.target.value);
  }

  render() {
    return (
      <span className="profile-btn-1">
        <Input id="themeChooser" title="Theme drop down selector"
                className="profile-btn-1 form-control"
          type="select"
          value={this.state.theme}
          onChange={this.switchTheme}>
          <option value='light'>default</option>
          <option value='high_contrast'>high contrast</option>
          <option value='powder'>powder</option>
          <option value='urban'>urban</option>
          <option value='vintage'>vintage</option>
        </Input>
      </span>
    );
  }
}